<template>
  <b-modal
    id="combine-options-modal"
    :title="trans('combine_options')"
    :ok-title="trans('apply')"
    :cancel-title="trans('cancel')"
    @ok="onSave"
    @shown="onShown"
  >
    <b-form-group>
      <b-form-radio-group v-model="selected">
        <b-form-radio
          v-for="o in options"
          :key="o.value"
          :value="o.value"
        >
          {{ o.text }}
          <small class="d-block ml-2 mb-2">
            {{ o.tooltip }}
          </small>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
    <p>
      <a href="/help/amilia#combine" target="_blank">
        <i class="fa fa-fw fa-info-circle"></i>
        {{ trans('read_the_docs') }}
      </a>
    </p>
  </b-modal>
</template>

<script>
  function deserialize(combine, allow_multiple) {
    if (!combine && !allow_multiple) return 'single'
    if (combine) return 'combine'
    return 'multiple'
  }

  export default {
    props: {
      combine: Boolean,
      allow_multiple: Boolean,
      what: {
        type: String,
        default: 'activity', // activity, memebership or class
      },
    },
    data() {
      return {
        trans: trans,
        selected: deserialize(this.combine, this.allow_multiple),
        options: [
          {value: 'single', text: trans(`import_single_${this.what}`), tooltip: trans(`import_single_${this.what}_about`)},
          {value: 'multiple', text: trans(`import_allow_multiple_${this.what}`), tooltip: trans(`import_allow_multiple_${this.what}_about`)},
          {value: 'combine', text: trans('import_combine_duplicates'), tooltip: trans('import_combine_duplicates_about')},
        ],
      }
    },
    methods: {
      onSave() {
        this.$emit('combine', this.selected == 'combine')
        this.$emit('allow_multiple', this.selected == 'multiple')
      },
      onShown() {
        this.selected = deserialize(this.combine, this.allow_multiple)
      }
    },
    mounted() {
      window.combineOptionsModal = this
    },
  }
</script>